/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TutorialTagRead } from './TutorialTagRead';
import {
    TutorialTagReadFromJSON,
    TutorialTagReadFromJSONTyped,
    TutorialTagReadToJSON,
    TutorialTagReadToJSONTyped,
} from './TutorialTagRead';

/**
 * Schema for reading a tutorial.
 * @export
 * @interface TutorialRead
 */
export interface TutorialRead {
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialRead
     */
    is_public?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialRead
     */
    deleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TutorialRead
     */
    complexity?: number;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    created_by_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TutorialRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof TutorialRead
     */
    created_by_name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialRead
     */
    organization_ids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialRead
     */
    organization_names?: Array<string>;
    /**
     * 
     * @type {Array<TutorialTagRead>}
     * @memberof TutorialRead
     */
    tags?: Array<TutorialTagRead>;
}

/**
 * Check if a given object implements the TutorialRead interface.
 */
export function instanceOfTutorialRead(value: object): value is TutorialRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function TutorialReadFromJSON(json: any): TutorialRead {
    return TutorialReadFromJSONTyped(json, false);
}

export function TutorialReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'language': json['language'] == null ? undefined : json['language'],
        'field': json['field'] == null ? undefined : json['field'],
        'created_by_id': json['created_by_id'] == null ? undefined : json['created_by_id'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
        'created_by_name': json['created_by_name'] == null ? undefined : json['created_by_name'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'organization_names': json['organization_names'] == null ? undefined : json['organization_names'],
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TutorialTagReadFromJSON)),
    };
}

export function TutorialReadToJSON(json: any): TutorialRead {
    return TutorialReadToJSONTyped(json, false);
}

export function TutorialReadToJSONTyped(value?: TutorialRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_public': value['is_public'],
        'deleted': value['deleted'],
        'complexity': value['complexity'],
        'language': value['language'],
        'field': value['field'],
        'created_by_id': value['created_by_id'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
        'created_by_name': value['created_by_name'],
        'organization_ids': value['organization_ids'],
        'organization_names': value['organization_names'],
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TutorialTagReadToJSON)),
    };
}

